import { DeliveryEntry } from '@telialt/common-order-cart/src/entries/DeliveryEntry';
import { PromotionEntry } from '@telialt/common-order-cart/src/entries/PromotionEntry';
import { ServiceEntry } from '@telialt/common-order-cart/src/entries/ServiceEntry';
import { SimCardEntry } from '@telialt/common-order-cart/src/entries/SimCardEntry';

import { DiscountEntryConnected } from './entries/DiscountEntryConnected';
import { DisneyVasConnected } from './entries/DisneyVasConnected';
import { GiftEntryConnected } from './entries/GiftEntryConnected';
import { InsuranceEntryConnected } from './entries/InsuranceEntryConnected';
import { MainProductEntryConnected } from './entries/MainProductEntryConnected';
import { MobRatePlanEntryConnected } from './entries/MobRatePlanEntryConnected';
import { NetflixVasConnected } from './entries/NetflixVasConnected';
import { UpsellEntryConnected } from './entries/UpsellEntryConnected';

export const DEFAULT_ENTRY_ORDER = [
    MainProductEntryConnected,
    InsuranceEntryConnected,
    GiftEntryConnected,
    MobRatePlanEntryConnected,
    ServiceEntry,
    NetflixVasConnected,
    DisneyVasConnected,
    PromotionEntry,
    SimCardEntry,
    UpsellEntryConnected,
    DeliveryEntry,
    DiscountEntryConnected,
];
